export function ignoreEventWhenSlider(e: KeyboardEvent) {
  return (e.target as HTMLElement).className.includes('slider');
}

export function handleKeyDown<T extends { jobID: string }>(
  e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
  showSuggestions: boolean,
  suggestions: { data: T[] },
  highlightedID: string,
  sethighlightedID: (suggestionID: string) => void,
  isSuggestionsActive: boolean,
  setIsSuggestionsActive: (active: boolean) => void,
) {
  if (!showSuggestions || suggestions.data.length === 0) return;

  // Up arrow: Activate suggestions and highlight first item
  if (e.key === 'ArrowUp' && !isSuggestionsActive) {
    e.preventDefault();
    setIsSuggestionsActive(true);

    const currentIndex = suggestions.data.findIndex(
      (item) => item.jobID === highlightedID,
    );

    // Move to next suggestion, wrap to start if at end
    const nextIndex = (currentIndex + 1) % suggestions.data.length;
    const nextSuggestionID = suggestions.data[nextIndex]?.jobID;
    if (nextSuggestionID) {
      sethighlightedID(nextSuggestionID);
    }
    return;
  }

  // Down arrow: Deactivate suggestions
  if (e.key === 'ArrowDown' && isSuggestionsActive) {
    e.preventDefault();
    setIsSuggestionsActive(false);
    sethighlightedID('');
    return;
  }

  // Left/Right navigation when suggestions are active
  if (
    isSuggestionsActive &&
    (e.key === 'ArrowRight' || e.key === 'ArrowLeft')
  ) {
    e.preventDefault();

    const currentIndex = suggestions.data.findIndex(
      (item) => item.jobID === highlightedID,
    );

    let nextIndex: number;
    if (e.key === 'ArrowRight') {
      // Move to next suggestion, wrap to start if at end
      nextIndex = (currentIndex + 1) % suggestions.data.length;
    } else {
      // Move to previous suggestion, wrap to end if at start
      nextIndex =
        currentIndex <= 0 ? suggestions.data.length - 1 : currentIndex - 1;
    }

    const nextSuggestionID = suggestions.data[nextIndex]?.jobID;
    if (nextSuggestionID) {
      sethighlightedID(nextSuggestionID);
    }
  }
}
